module.exports = __webpack_public_path__ + "static/media/Fichier 18.6ecedf82.svg";